import { useEffect } from 'react'
import { useProfile } from 'context/Profile'

const Theme = ( {
  children
} ) => {
  const profile = useProfile()

  useEffect( () => {
    Object
      .keys( profile.themeParams )
      .forEach( k => {
        document
          .documentElement
          .style
          .setProperty(
            `--${ k }`,
            profile.themeParams[ k ]
          )
      } )
  } )

  return children
}

export default Theme
